<div class="page-container">
  <!-- HEADER -->
  <header class="page-header">
    <span class="eyebrow">Support</span>
    <h1 class="page-title">Help Center</h1>
    <p class="page-subtitle">
      Frequently asked questions and guidance for equipment rentals, timesheets, and vendor operations on Aluguloo.
    </p>

    <!-- SEARCH BAR -->
    <div class="search-box">
      <svg class="search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
      <input 
        type="text" 
        [(ngModel)]="searchQuery" 
        placeholder="Search topics, keywords, questions..."
        aria-label="Search FAQ" />
      <button *ngIf="searchQuery" class="clear-btn" (click)="searchQuery = ''">✕</button>
    </div>
  </header>

  <!-- CATEGORY PILLS (only when not searching) -->
  <div class="category-tabs" *ngIf="!searchQuery">
    <button 
      *ngFor="let cat of faqCategories; let i = index"
      class="tab-btn" 
      [class.active]="activeCategoryIndex === i"
      (click)="selectCategory(i)">
      {{ cat.title }}
    </button>
  </div>

  <!-- FAQ LIST -->
  <main class="faq-section">
    <div *ngIf="searchQuery" class="search-results-info">
      Showing {{ displayedItems.length }} result(s) for "{{ searchQuery }}"
    </div>

    <div *ngIf="displayedItems.length === 0" class="no-results">
      <p>No questions matched your search query. Contact support directly for assistance.</p>
    </div>

    <div class="faq-list">
      <div 
        *ngFor="let item of displayedItems" 
        class="faq-item" 
        [class.open]="item.open">
        <button class="faq-question" (click)="toggleFaq(item)">
          <span>{{ item.question }}</span>
          <span class="chevron" [class.rotated]="item.open">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </span>
        </button>
        <div class="faq-answer" *ngIf="item.open">
          <p>{{ item.answer }}</p>
        </div>
      </div>
    </div>
  </main>

  <!-- SUPPORT FOOTER CARD -->
  <footer class="support-footer">
    <div class="support-text">
      <h3>Need direct assistance?</h3>
      <p>Consult our platform policies or review operational responsibilities.</p>
    </div>
    <div class="support-actions">
      <a routerLink="/rental-responsibility" class="btn primary-btn">Rental Responsibility</a>
      <a routerLink="/company-details" class="btn secondary-btn">Company Details</a>
    </div>
  </footer>
</div>
